import { render, staticRenderFns } from "./SelfProfile.vue?vue&type=template&id=71ea4acd&"
import script from "./SelfProfile.vue?vue&type=script&lang=js&"
export * from "./SelfProfile.vue?vue&type=script&lang=js&"
import style0 from "./SelfProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports